export const checkIntegrationsFetching = ({ integrations: { fetchingIntegrations } }) => fetchingIntegrations;
